<template>
  <!--Breadcrumb-->
  <div id="breadcrumb_cls" class="breadcrumb d-none-cls d-md-block mb-0">
    <ul>
      <li>
        <router-link :to="{ name: 'home' }">{{ _T('Home') }}</router-link>
      </li>
      <li v-if="currentStore">
        <span>></span>
        {{ _T_DB(currentStore, 'name') }}
      </li>
      <li>
        <span v-if="$route.params.category_name">></span>
        {{ $route.params.category_name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
export default {
  mixins: [Windowsize],
  data() {
    return {
      fixTop: false,
      txt: '',
      data: this.$router.currentRoute.params.category_name,
    }
  },
  computed: {
    ...mapGetters(['_T', 'currentStore', '_T_DB']),
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleScroll(event) {
      if (window.scrollY > 300) this.fixTop = true
      else this.fixTop = false
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  #breadcrumb_cls {
    text-align: right !important;
  }
}
.breadcrumb {
  &.d-md-block {
    &.d-none {
      display: none !important;
    }
  }
  &.fixed_top {
    position: fixed;
    width: 75%;
    flex: 0 0 75%;
    max-width: 75%;
    top: $px227;
    z-index: 1;
    &.sticky_up {
      top: $px86;
    }
  }
  ul {
    li {
      text-transform: capitalize;
      span {
        color: $primary-color;
        padding-right: $px3;
      }
      + li {
        padding-left: $px5;
      }
    }
  }
}
@media (max-width: 1367px) {
  .breadcrumb {
    &.fixed_top {
      top: $px224;
    }
  }
}
@media (max-width: 1199px) {
  .breadcrumb {
    &.fixed_top {
      flex: 0 0 66.67%;
      max-width: 66.67%;
      width: 66.67%;
      top: $px199;
    }
  }
}
@media (max-width: 991px) {
  .breadcrumb {
    &.fixed_top {
      top: $px199;
      width: 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
@media (max-width: 767px) {
  .d-md-block {
    &.d-none-cls {
      display: none !important;
    }
  }
}
</style>
